import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/folder-icon.svg'


const _hoisted_1 = { class: "d-flex ga-5" }
const _hoisted_2 = { class: "d-flex flex-column ga-1 w-100" }
const _hoisted_3 = { class: "d-flex justify-space-between w-100 align-center" }
const _hoisted_4 = { class: "d-flex ga-2" }
const _hoisted_5 = { class: "f-body-1" }
const _hoisted_6 = {
  key: 0,
  class: "f-body-1 mt-5"
}
const _hoisted_7 = {
  key: 1,
  class: "mt-5 d-flex flex-column ga-1"
}
const _hoisted_8 = { class: "d-flex ga-3 flex-wrap" }
const _hoisted_9 = { class: "mt-5 d-flex flex-column ga-1" }
const _hoisted_10 = { class: "d-flex ga-3 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "b-dark" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("div", null, [
              _createElementVNode("img", {
                class: "item-card-icons",
                src: _imports_0
              })
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.getJobName(_ctx.jobPreferences.WorkingPosition)), 1),
                _createElementVNode("div", _hoisted_4, [
                  (!_ctx.isHiringmanager)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: "mdi-pen",
                        class: "c-black b-white",
                        disabled: _ctx.loading,
                        onClick: _ctx.edit
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isHiringmanager)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        icon: "mdi-delete",
                        class: "c-black b-white",
                        disabled: _ctx.loading,
                        onClick: _ctx.remove
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.jobPreferences.SeiorityLevel) + " - " + _toDisplayString(_ctx.jobPreferences.PositionExperienceYear) + " Years Experience", 1),
              (_ctx.jobPreferences.Amount && _ctx.jobPreferences.Amount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "$" + _toDisplayString(_ctx.jobPreferences.Amount) + " per Hour", 1))
                : _createCommentVNode("", true),
              (_ctx.jobPreferences.PreferredLocation && _ctx.jobPreferences.PreferredLocation.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "f-body-1 mb-2" }, "Location:", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPreferences.PreferredLocation, (item, index) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          key: index,
                          class: "b-charcoal"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "f-body-1 mb-2" }, "Employment Type:", -1)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPreferences.EmploymentType, (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      key: index,
                      class: "b-charcoal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}